import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const RecurringPlannersApi = createApi({
  reducerPath: "RecurringPlanners",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1/recurring-planners`,
    credentials: "include",
  }),
  tagTypes: ["RecurringPlanner"],
  endpoints: (builder) => ({
    getAllRecurringPlanners: builder.query({
      query: ({
        page = 1,
        limit,
        sortBy,
        sortOrder,
        search,
        status,
        assignedToId,
        createdById,
      } = {}) => {
        const queryParams = new URLSearchParams();
        if (page) queryParams.append("page", page);
        if (limit) queryParams.append("limit", limit);
        if (sortBy) queryParams.append("sortBy", sortBy);
        if (sortOrder) queryParams.append("sortOrder", sortOrder);
        if (search) queryParams.append("search", search);
        if (status) queryParams.append("status", status);
        if (assignedToId) queryParams.append("assignedToId", assignedToId);
        if (createdById) queryParams.append("createdById", createdById);
        return `?${queryParams.toString()}`;
      },
    }),
    getSingleRecurringPlanner: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "RecurringPlanner", id }],
    }),
    createRecurringPlanner: builder.mutation({
      query: (payload) => ({
        url: "",
        method: "POST",
        body: payload,
      }),
    }),
    editRecurringPlanner: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "RecurringPlanner", id },
      ],
    }),
    pauseResumeRecurringPlanner: builder.mutation({
      query: ({ id, action }) => ({
        // action: "pause" | "resume"
        url: `/${id}/pause-resume`,
        method: "PATCH",
        body: { action },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "RecurringPlanner", id },
      ],
    }),
    cancelRecurringPlanner: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "RecurringPlanner", id },
      ],
    }),
  }),
});

export const {
  useGetAllRecurringPlannersQuery,
  useGetSingleRecurringPlannerQuery,
  useCreateRecurringPlannerMutation,
  useEditRecurringPlannerMutation,
  usePauseResumeRecurringPlannerMutation,
  useCancelRecurringPlannerMutation,
} = RecurringPlannersApi;
